import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  apiPrefix: string;
  headers = new HttpHeaders();

  constructor(private http: HttpClient) {
    this.apiPrefix = environment.baseUrl + 'api/v1/contact/';
    this.headers = this.headers.set(
      'x-access-token',
      localStorage.getItem('adventouresAdminAuthToken')
    );
  }

  createContact(params) {
    return this.http.post(this.apiPrefix + 'create', params, {
      headers: this.headers,
    });
  }

  updateContact(params) {
    return this.http.post(this.apiPrefix + 'update', params, {
      headers: this.headers,
    });
  }

  getContact(params) {
    return this.http.post(this.apiPrefix + 'get', params, {
      headers: this.headers,
    });
  }
  getContactUs(params) {
    return this.http.post(this.apiPrefix + 'get-website', params, {
      headers: this.headers,
    });
  }
}
